var moduleMap = {
	"./styles": () => {
		return __webpack_require__.e(/* __federation_expose_styles */ "__federation_expose_styles").then(() => (() => ((__webpack_require__(69249)))));
	},
	"./Constants": () => {
		return Promise.all(/* __federation_expose_Constants */[__webpack_require__.e("vendors-node_modules_lodash_isEmpty_js"), __webpack_require__.e("vendors-node_modules_rxjs_dist_esm5_internal_operators_catchError_js-node_modules_rxjs_dist_e-5ab992"), __webpack_require__.e("vendors-node_modules_io-ts-types_lib_UUID_js-node_modules_rxjs_dist_esm5_internal_ajax_ajax_js"), __webpack_require__.e("webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("webpack_sharing_consume_default_react-router-dom_react-router-dom"), __webpack_require__.e("webpack_sharing_consume_default_clsx_clsx"), __webpack_require__.e("libs_sds_src_Icons_index_ts-webpack_sharing_consume_default_lodash_lodash-webpack_sharing_con-4a9802"), __webpack_require__.e("webpack_sharing_consume_default_squiz_dxp-console-support_squiz_dxp-console-support"), __webpack_require__.e("webpack_sharing_consume_default_squiz_sds_squiz_sds"), __webpack_require__.e("apps_administration_src_Constants_DxpCapabilities_constants_tsx-apps_administration_src_Const-4624e3"), __webpack_require__.e("__federation_expose_Constants")]).then(() => (() => ((__webpack_require__(81929)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};

__webpack_require__(64167)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});